import IconArrow from '@/assets/icons/arrow.svg';

export default {
  name: 'TabMenu',
  props: {
    items: Object,
    currentTab: String,
    isFullWidth: {
      type: Boolean,
      default: true
    },
    toShowBack: Boolean
  },
  components: {
    IconArrow
  },
  computed: {
    menuItems: function() {
      const { items } = this;
      return Object.keys(items).map(key => ({ ...items[key], key }));
    }
  },
  methods: {
    goBack: function() {
      return this.$router.go(-1);
    }
  }
};
